import { Box, Link, Typography } from "@mui/material";
import React, { useState } from "react";

const Footer = () => {
  const [isHover, setIsHover] = useState(false);
  const handleOpenMail = () => {
    const mailtoLink = "mailto:yogeshyadavyj@gmail.com";
    window.location.href = mailtoLink;
  };
  return (
    <div>
      <Box
        sx={{
          padding: 5,
          display: "flex",
          backgroundColor: "#000",
          color: "#fff",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: "30px", sm: 0 },
          justifyContent: "space-between",
        }}
      >
        <Box textAlign={"left"}>
          <Typography variant="h5">Elevating products with purpose, precision, and a touch of innovation.</Typography>
          <Typography variant="subtitle1">
            Created with care and creativity by Yogesh & Shorya. 🎨💙
          </Typography>
        </Box>

        <Box
          component={"div"}
          sx={{
            borderRadius: "28px",
            backgroundColor: "#fff",
            overflow: "hidden",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            cursor: "pointer",
            // width: "12%",
          }}
          display={"flex"}
          px={1}
          py={1}
          onClick={handleOpenMail}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <Link
            sx={{
              display: "flex",
              width: "fit-content",
              textDecoration: "none",
              color: "#000",
              fontSize: { xs: ".8rem", sm: "1.2rem" },
              fontWeight: 700,
              paddingLeft: "4px",
            }}
          >
            Drop a Line to connect!{" "}
          </Link>
          <Box
            display={"flex"}
            width={"40px"}
            height={"40px"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Box
              sx={{
                width: isHover ? "40px" : "10px",
                height: isHover ? "40px" : "10px",
                borderRadius: "50%",
                backgroundColor: "#000",
                transition: "all .2s ease-in-out",
              }}
            >
              {isHover && <p style={{ fontSize: "30px" }}>💙</p>}
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default Footer;
